export default function SkillsAfterTraining() {
  const skills = [
    { icon: 'ri-brain-line', title: 'Понимают психологию возражений', desc: 'Знают, почему клиенты возражают и что стоит за каждым «нет»' },
    { icon: 'ri-forbid-line', title: 'Не спорят с клиентом', desc: 'Умеют переводить конфликт в диалог и сотрудничество' },
    { icon: 'ri-shield-check-line', title: 'Не оправдываются', desc: 'Ведут разговор с позиции эксперта, а не просителя' },
    { icon: 'ri-price-tag-3-line', title: 'Не продают скидку', desc: 'Продают ценность и умеют защищать цену при возражениях' },
    { icon: 'ri-user-follow-line', title: 'Умеют удерживать клиента', desc: 'Не бросают разговор на полпути, доводят до результата' },
    { icon: 'ri-questionnaire-line', title: 'Задают сильные вопросы', desc: 'Выявляют истинные причины возражений через правильные вопросы' },
    { icon: 'ri-vip-diamond-line', title: 'Усиливают ценность', desc: 'Показывают клиенту выгоду, которую он ещё не увидел' },
    { icon: 'ri-team-line', title: 'Закрывают сделки увереннее', desc: 'Конверсия растёт, потому что менеджеры не пасуют перед «нет»' },
  ];

  return (
    <section id="skills" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Что сотрудники получают после обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Не теория. Не скрипты. Реальные изменения в поведении, которые видны по показателям уже через 2–4 недели.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {skills.map((skill, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 text-center hover:bg-teal-50 transition-colors duration-300 border border-gray-100 hover:border-teal-200">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className={`${skill.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2 leading-snug">{skill.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{skill.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}